export default __webpack_public_path__ + "static/media/5.411a4c38.svg";